module.exports = __webpack_public_path__ + "img/de.0a2018b0.svg";